import React from 'react';

import TIModal from '@components/TIModal';
import { ForumPost } from '@utils/backend-api/forumPosts';

import ShareModalContent from './ShareModalContent';
import styles from './styles.module.scss';

export default function ShareModal({
  forumPost,
  isOpen,
  setIsOpen,
  onDownloadScreenshot,
}: {
  forumPost: ForumPost;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onDownloadScreenshot: () => void;
}) {
  return (
    <TIModal
      isOpen={isOpen}
      disableScrollLock={false}
      onClose={() => setIsOpen(false)}
      parentClass={styles.shareModal}
    >
      <ShareModalContent forumPost={forumPost} onDownloadScreenshot={onDownloadScreenshot} />
    </TIModal>
  );
}
